module.exports = __webpack_public_path__ + "img/block.afb16fe1.svg";